// Single source of truth for profile tag dictionaries.
// Used by the profile edit form (Profile.js) and the browse filter
// (Browse.js / FilterPanel.js) so options never drift apart.

export const PERSONALITY_TRAITS = [
  '實際', '穩重', '幽默', '體貼', '溫暖', '理性', '外向', '內向',
  '冒險', '創新', '樂觀', '認真', '浪漫', '獨立', '靈活', '精確'
];

export const INTERESTS = [
  '烹飪', '攝影', '登山', '旅遊', '美食', '電影', '音樂',
  '運動', '閱讀', '繪畫', '咖啡', '寵物', '游泳', '舞蹈', '短劇'
];
